import { authenticatedPost } from './api_service';

const EventService = {
  submitEvent: (data) => {
    return authenticatedPost('/api/events/', data);
  }
}

export default EventService;
